module.exports = __webpack_public_path__ + "img/ddzx.877fb9b5.png";